import React, { useState, useEffect } from "react";
import { Form, Input, Select, Space } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";

const Fragment = ({ field, remove, role, roles }) => {
  const [ids, setIds] = useState("");
  const { key, name, ...restField } = field;

  useEffect(() => {
    const initialRole = roles.find(item => item.role_id === role);
    if (initialRole) {
      setIds(initialRole.desc);
    }
  }, [role, roles]);

  const handleChange = value => {
    const selectedRole = roles.find(item => item.role_id === value);
    if (selectedRole) {
      setIds(selectedRole.role_id);
    }
  };

  // 搜索过滤函数
  const filterOption = (input, option) => {
    return (option?.children ?? "").toLowerCase().includes(input.toLowerCase());
  };

  return (
    <Space
      align="baseline"
      style={{ marginLeft: "75px" }}
      key={key}
    >
      <Form.Item
        {...restField}
        label="角色"
        name={[name]}
        style={{ marginRight: "10px" }}
      >
        <Select
          style={{
            width: 250,
          }}
          onChange={handleChange}
          defaultValue={role}
          showSearch
          placeholder="请输入角色名称"
          optionFilterProp="children"
          filterOption={filterOption}
        >
          {roles.map(item => (
            <Select.Option
              key={item.id}
              value={item.role_id}
            >
              {item.desc}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        label="描述"
        {...restField}
      >
        <Input
          value={ids}
          disabled
          style={{
            width: 250,
          }}
        />
      </Form.Item>
      <MinusCircleOutlined
        onClick={() => {
          remove(name);
        }}
      />
    </Space>
  );
};

export default Fragment;
